import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-596687f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Align this color. ")
const _hoisted_2 = {
  key: 1,
  class: "k-color-text mb2"
}
const _hoisted_3 = { class: "k-gradient-bg" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Align these colors. ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Tap (anywhere) in sequence to stop each ring and align the colors. ", -1))

import * as GameTypes from 'types/game.types';
import { onBeforeUnmount, onMounted, ref, UnwrapRef } from 'vue';
import { useModule } from 'src/modules/modules';
import GameContentArea from '../game-content-area.vue';
import ContrastText from '../contrast-text.vue';
import { getColorWithSimilarityInRange, getRandomNonUglyColor, interpolate } from 'util/color-util';
import { RadialColorAligner } from '../radial-color-aligner';
import { hapticsImpactLight } from 'util/device-util';
import BaseScene from 'src/scenes/base';
import chroma from 'chroma-js';
import { ascending } from 'util/audio-util';


export default /*#__PURE__*/_defineComponent({
  __name: 'align-disks',
  emits: ['next', 'fail'],
  setup(__props, { expose, emit }) {

const { game, audio } = useModule();
game.clock.stop();

const tones = ascending('FX_ascending_', 1, 8);


const colors : chroma.Color[][] = [];
const targetColor = ref<chroma.Color>(chroma.random());
const variation = ref<number>(0);
const state = ref({
    distanceMin: 49,
    distanceMax: 100,
    slices: 4,
    tiers: 3,
    duration: 15000
})

/**
 * Each tier contains a unique set of colors, except for the target color which is present in all tiers at
 * the first position. As difficulty increases, the number of tiersa nd slices increases, and the distance between
 * colors is reduced.
 */
const variation1 = () => {
    variation.value = 1;
    console.log(`Align Disks: Variation 1, Difficulty ${game.matchState.difficulty}`);
    if (game.matchState.difficulty === 0){
        state.value = {
            distanceMin: 50,
            distanceMax: 90,
            slices: 4,
            tiers: 3,
            duration: 10000
        }
    } else if (game.matchState.difficulty === 1){
        state.value = {
            distanceMin: 40,
            distanceMax: 80,
            slices: 8,
            tiers: 4,
            duration: 12000
        }
    } else if (game.matchState.difficulty === 2){
        state.value = {
            distanceMin: 30,
            distanceMax: 70,
            slices: 12,
            tiers: 4,
            duration: 15000
        }
    } else if (game.matchState.difficulty === 3){
        state.value = {
            distanceMin: 20,
            distanceMax: 50,
            slices: 12,
            tiers: 5,
            duration: 25000
        }
    } else if (game.matchState.difficulty >= 4){
        state.value = {
            distanceMin: 10,
            distanceMax: 30,
            slices: 12,
            tiers: 5,
            duration: 25000
        }
    }

    for (let i = 0; i < state.value.tiers; i++){
        colors[i] = [];
        colors[i][0] = targetColor.value; //Assign our target color to the first position
        for (let j = 1; j < state.value.slices; j++){
            //if index is odd, push a blank color (black), will not be renderd by radial color aligner
            if (j % 2 !== 0){
                colors[i].push(chroma('black')); 
                continue;
            } else {
                colors[i].push(
                    getColorWithSimilarityInRange(
                        targetColor.value, 
                        state.value.distanceMin, 
                        state.value.distanceMax
                    )
                )
            }
        }
    }
}

/**
 * Each tier contains the exact same colors in the same order, however 
 */
const variation2 = () => {
    variation.value = 2;
    console.log(`Align Disks: Variation 2, Difficulty ${game.matchState.difficulty}`);
    if (game.matchState.difficulty === 0){
        state.value = {
            distanceMin: 50,
            distanceMax: 100,
            slices: 4,
            tiers: 3,
            duration: 10000
        }
    } else if (game.matchState.difficulty === 1){
        state.value = {
            distanceMin: 40,
            distanceMax: 90,
            slices: 8,
            tiers: 4,
            duration: 12000
        }
    } else if (game.matchState.difficulty === 2){
        state.value = {
            distanceMin: 30,
            distanceMax: 80,
            slices: 12,
            tiers: 4,
            duration: 12000
        }
    } else if (game.matchState.difficulty === 3){
        state.value = {
            distanceMin: 20,
            distanceMax: 40,
            slices: 16,
            tiers: 4,
            duration: 20000
        }
    } else if (game.matchState.difficulty >= 4){
        state.value = {
            distanceMin: 10,
            distanceMax: 25,
            slices: 12,
            tiers: 4,
            duration: 20000
        }
    }

    let colorsAll : chroma.Color[] = [];
    for (let j = 0; j < state.value.slices; j++){
        if (j % 2 !== 0){
            colorsAll.push(chroma('black')); 
            continue;
        } else {
            colorsAll.push(
                getColorWithSimilarityInRange(
                    targetColor.value, 
                    state.value.distanceMin, 
                    state.value.distanceMax
                )
            )
        }
    }

    for (let i = 0; i < state.value.tiers; i++){
        colors[i] = colorsAll;
    }
}


/**
 * Each tier contains one color of a gradient which must be completed
 */
const gradientColors = ref<chroma.Color[]>([]);
const variation3 = () => {
    variation.value = 3;
    console.log(`Align Disks: Variation 3, Difficulty ${game.matchState.difficulty}`);
    if (game.matchState.difficulty === 0){
        state.value = {
            distanceMin: 50,
            distanceMax: 100,
            slices: 4,
            tiers: 3,
            duration: 12000
        }
    } else if (game.matchState.difficulty === 1){
        state.value = {
            distanceMin: 40,
            distanceMax: 90,
            slices: 8,
            tiers: 4,
            duration: 15000
        }
    } else if (game.matchState.difficulty === 2){
        state.value = {
            distanceMin: 35,
            distanceMax: 80,
            slices: 12,
            tiers: 4,
            duration: 15000
        }
    } else if (game.matchState.difficulty === 3){
        state.value = {
            distanceMin: 30,
            distanceMax: 70,
            slices: 16,
            tiers: 4,
            duration: 20000
        }
    } else if (game.matchState.difficulty >= 4){
        state.value = {
            distanceMin: 30,
            distanceMax: 55,
            slices: 12,
            tiers: 4,
            duration: 20000
        }
    }

    targetColor.value = getRandomNonUglyColor();
    let c2 = getColorWithSimilarityInRange(targetColor.value, state.value.distanceMin, state.value.distanceMax);
    gradientColors.value = interpolate(targetColor.value, c2, state.value.tiers);

    for (let i = 0; i < state.value.tiers; i++){
        colors[i] = [];
        colors[i][0] = gradientColors.value[i]; //Assign our next gradient step to the first position
        for (let j = 1; j < state.value.slices; j++){
            //if index is odd, push a blank color (black), will not be renderd by radial color aligner
            if (j % 2 !== 0){
                colors[i].push(chroma('black')); 
                continue;
            } else {
                //Assign a random and not-too-similar color to the other positions
                colors[i].push(
                    getColorWithSimilarityInRange(targetColor.value, 50, 100)
                )
            }
        }
    }

    // for (let i = 0; i < state.value.tiers; i++){
    //     colors[i] = colorsAll;
    // }
}

/**
 * Randomly select a game variation. Variation 3 is only available on once the
 * difficult increases.
 */
let variations = [variation1, variation2];
if (game.matchState.difficulty >= 2){
    variations.push(variation3);
}

Phaser.Utils.Array.GetRandom(variations)();

let scene : UnwrapRef<BaseScene> = game.gameScene!;
let radial = new RadialColorAligner(<BaseScene> scene, colors, { 
    speed: Phaser.Math.Between(50, 70) / 100,
    radius: (game.gameScene!.cameras.main.width / 2) * .8,
    strokeWidth: 22,
    //direction: sample(['random', 'left', 'random', 'right', 'random'])!,
    direction: 'random',
    y: '50%' 
});

const lockTier = async () => {
    hapticsImpactLight();
    radial.lockTier();
}

/**
 * Graceful unmount for Phaser components during game over
 */
onBeforeUnmount(async () => {
    radial.destroy()
});

onMounted(async () => {
    await Promise.all([radial.enter()]);
    game.clock.start(state.value.duration);
})

const container = ref();
const picker = ref();
const leave = () => {
    return Promise.all([
        picker.value?.leave(),
        container?.value.leave(),
        radial.leave()
    ]);
}

/**
 * The "complete" event is emitted immediately after the player has locked in the last tier
 * but before all of the animations have completed. This exists so that we can stop the clock
 * so it won't still run during final animations.
 */
radial.on('complete', () => game.clock.pause());
radial.on('fail', () => emit('fail'));
radial.on('lock', () => tones.next());
radial.on('success', (avgAccuracy: number) => {
    game.matchState.precisionRounds += 1;
    game.clock.pause()
    /**
     * Add multiplier for a good average lock-in score
     */
    let multipliers = [];
    if (avgAccuracy > .85){
        let factor = 1;
        if (avgAccuracy >= .9) factor = 3;
        if (avgAccuracy > .95) factor = 6;
        multipliers.push({
            factor,
            label: 'Precision Bonus',
        })

        game.matchState.precisionCount += 1;
    }

    emit('next', <GameTypes.MatchCompleteData> {
        baseScore: (game.matchState.difficulty + 1) * 25,
        scoreMultipliers: multipliers,
        background: colors[0][0]
    })
});

expose({
    leave
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GameContentArea, {
    ref_key: "container",
    ref: container,
    onDown: lockTier,
    onSkip: _cache[0] || (_cache[0] = () => emit('next', { skipped: true }))
  }, {
    instruction: _withCtx(() => [
      (variation.value === 1)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "k-color-text mb2",
            style: _normalizeStyle({ background: targetColor.value.hex() })
          }, [
            _createVNode(ContrastText, { color: targetColor.value }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }, 8, ["color"])
          ], 4))
        : (variation.value === 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gradientColors.value, (c) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "k-gradient-bg__step",
                    style: _normalizeStyle({ background: c.hex() })
                  }, null, 4))
                }), 256))
              ]),
              _createVNode(ContrastText, { color: targetColor.value }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["color"])
            ]))
          : _createCommentVNode("", true),
      _hoisted_5
    ]),
    _: 1
  }, 512))
}
}

})